import {Image as ImagePresentation} from './image'

export interface ImageProps {
  event: wix.events.Event
  containerWidth?: number | string
  squareImage?: boolean
}

export const Image = ImagePresentation
